export enum MarketplaceAgsServicePermissionStatus {
  NotActive = 0,
  Active = 1
}
